import StatefulLandingContainer from './StatefulLandingContainer';

export default {
  path: '/testtest',

  getComponents(location, cb) {
    cb(null, StatefulLandingContainer);
  },
};
